import isEmpty from 'lodash/isEmpty'
import * as Redux from 'redux'
import * as ReduxObservable from 'redux-observable'
import 'rxjs/add/operator/debounceTime'
import 'rxjs/add/operator/distinctUntilChanged'
import 'rxjs/add/operator/filter'
import 'rxjs/add/operator/map'
import 'rxjs/add/operator/switchMap'
import * as App from '../../app'
import * as FlashMessage from '../../components/flash-message'
import * as Form from '../../components/form'
import * as IsActive from '../../components/is_active'
import * as Menu from '../../components/menu'
import * as Request from '../../request'
import {ApplicationState} from '../../rootReducer'
import * as Router from '../../router'
import * as Schedules from '../schedules'
import * as Actions from './actions'
import * as Constants from './constants'
import * as Types from './types'

const onEnter = (
  action$: ReduxObservable.ActionsObservable<Redux.Action>,
  store: Redux.Store<ApplicationState>,
  {history}: App.Dependencies,
) => action$.ofType(Router.ON_ENTER)
  .filter(() => history.location.pathname.startsWith(Menu.SUBSCRIBERS_SUBSCRIBER_DETAIL_URL))
  .map((action: Router.OnEnterAction) =>
    Actions.fetchMemberDetails(
      store.getState().app.selectedCommunity,
      action.params.memberIdentifier))

const onFetchEmptySuccess = (
  action$: ReduxObservable.ActionsObservable<any>,
  store: Redux.Store<ApplicationState>,
  {history}: App.Dependencies,
) => action$.ofType(Request.successConstant(Constants.FETCH_MEMBER_DETAILS))
  .filter((action) => isEmpty(action.payload.response.basic.results))
  .mapTo(Router.push(Menu.SUBSCRIBERS_URL_HOME))

const onSaveRequest = (
  action$: ReduxObservable.ActionsObservable<Form.SaveAction<Types.Member>>,
  store: Redux.Store<ApplicationState>,
) => action$.ofType(Constants.FormConstants[Form.SAVE])
  .map((action) => Actions.updateMemberDetails(store.getState().app.selectedCommunity, action.value))

const onSaveSuccess = (
  action$: ReduxObservable.ActionsObservable<Form.SaveAction<Types.Member>>,
  store: Redux.Store<ApplicationState>,
) => action$.ofType(Request.successConstant(Constants.UPDATE_MEMBER_DETAILS))
  .mergeMap((action) => ([
    Constants.EditFieldActions[Form.EXIT](action),
    FlashMessage.showFlashMessage('Success!'),
  ]),
)
const onSaveFail = (
  action$: ReduxObservable.ActionsObservable<Form.SaveAction<Types.Member>>,
  store: Redux.Store<ApplicationState>,
) => action$.ofType(Request.errorConstant(Constants.UPDATE_MEMBER_DETAILS))
  .mergeMap((action) => ([
    Constants.EditFieldActions[Form.CANCEL](action),
    FlashMessage.showFlashError('Oops something went wrong'),
  ]))

const onUpdateStatusRequest = (
    action$: ReduxObservable.ActionsObservable<IsActive.StateChangeActionObject>,
    store: Redux.Store<ApplicationState>,
  ) => action$.ofType(Constants.UPDATE_MEMBER_DETAILS_UPDATE_STATUS)
    .map((action) => Actions.updateIsActive(store.getState().app.selectedCommunity, action.change))

export const epic = ReduxObservable.combineEpics(
  onEnter,
  onFetchEmptySuccess,
  onSaveRequest,
  onSaveSuccess,
  onSaveFail,
  onUpdateStatusRequest,
  Schedules.pageLoadEpic(Menu.SUBSCRIBERS_SUBSCRIBER_DETAIL_URL),
)



// WEBPACK FOOTER //
// ./src/pages/member-details/epic.ts